'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('csshake');

var _rocket = require('./assets/rocket.mp3');

var _rocket2 = _interopRequireDefault(_rocket);

var _SoundPlayer = require('../SoundPlayer/SoundPlayer');

var _SoundPlayer2 = _interopRequireDefault(_SoundPlayer);

var _Launcher = require('./components/Launcher.RocketLaunch');

var _Launcher2 = _interopRequireDefault(_Launcher);

var _Pack = require('./components/Pack.RocketLaunch');

var _Pack2 = _interopRequireDefault(_Pack);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Assets
// Components


var RocketLaunch = function (_Component) {
  _inherits(RocketLaunch, _Component);

  function RocketLaunch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RocketLaunch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RocketLaunch.__proto__ || Object.getPrototypeOf(RocketLaunch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      shake: '',
      status: null,
      hide: false,
      transition: {
        x: 0,
        y: 0
      }
    }, _this.launch = function () {
      _this.setState({
        shake: 'shake-slow',
        status: 'prepare'
      });

      setTimeout(function () {
        _this.setState({
          shake: 'shake'
        });

        _this.audio.play();
      }, 500);
      setTimeout(function () {
        return _this.setState({
          shake: '',
          status: 'launch'
        });
      }, 1500);
      setTimeout(function () {
        _this.setState({
          hide: true
        });

        _this.props.onFinish();
      }, 3000);
    }, _this.transitionPos = function (content) {
      if (!content) return;
      var dom = content.getBoundingClientRect();
      var x = 84 - dom.left;
      var y = window.innerHeight - 98 - dom.bottom;

      _this.setState({
        transition: {
          x: x,
          y: y
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RocketLaunch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.launch) this.launch();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.launch && this.props.launch) this.launch();
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var children = this.props.children;
      var _state = this.state,
          shake = _state.shake,
          status = _state.status,
          transition = _state.transition;
      return _react2.default.createElement('div', {
        key: 'rocketlaunchercontent',
        ref: this.transitionPos
      }, _react2.default.createElement(_Pack2.default, {
        pack: shake === 'shake' || status === 'launch',
        transition: transition
      }, children), _react2.default.createElement(_Launcher2.default, {
        status: status,
        shake: shake
      }));
    }
  }, {
    key: 'renderSoundPlayer',
    value: function renderSoundPlayer() {
      var _this2 = this;

      var status = this.state.status;
      return _react2.default.createElement(_SoundPlayer2.default, {
        key: 'rocketlaunchersoundplayer',
        src: _rocket2.default,
        fade: status === 'launch',
        fadeLength: 1000,
        reference: function reference(dom) {
          _this2.audio = dom;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var hide = this.state.hide;
      return hide ? null : [this.renderContent(), this.renderSoundPlayer()];
    }
  }]);

  return RocketLaunch;
}(_react.Component);

RocketLaunch.propTypes = {
  children: _propTypes2.default.node,
  launch: _propTypes2.default.bool,
  onFinish: _propTypes2.default.func
};
RocketLaunch.defaultProps = {
  launch: false,
  onFinish: function onFinish() {}
};
exports.default = RocketLaunch;